import React, { Fragment } from 'react';
import DisplayCode1 from '../../../../components/DisplayCode1/displayCode1';
import DisplayCode2 from '../../../../components/DisplayCode2/DisplayCode2';
import DisplayCodeKo from '../../../../components/DisplayCodeKo/DisplayCodeKo';

const Crear_Solucion_EN = () => {

  const codes = {
    answe_ok1: {
      title: "Answer ok",
      type: "json",
      code: `{
        "status": <boolean>,
        "result": <integer>
        "elapsed": <float>,
        "codtran": <string>
    }`,
      copied: false
    }
  };

  const codesMutiple = {
    selected: {
      id: "python",
      type: "python",
      code: ` import requests
    url = "URL_BASE/ws/ws_soluciones.py/gestorsoluciones"
    payload1 = {
    'country_code': 'MX',
    'user_id': '4532',
    'session_id': '439-InjyJc39dwPumPisHS5xgw==',
    'solution_type': '1',
    'command': 'create',
    'name': 'Lorem ipsum dolor sit amet.',
    'from': '2020-07-09',
    'until': '2020-08-09',
    'point_value': '1'
    }
    files = []
    headers= {}
    response1 = requests.request("POST", url, headers=headers, data = payload1, files = files)
    payload2 = {
    'country_code': 'MX',
    'user_id': '4532',
    'session_id': '439-InjyJc39dwPumPisHS5xgw==',
    'solution_type': '2',
    'command': 'create',
    'name': 'Lorem ipsum dolor sit amet.',
    'from': '2020-07-09',
    'until': '2020-08-09',
    'condiciones_aceptacion': 'Lorem ipsum dolor sit amet.'
    }
    response2 = requests.request("POST", url, headers=headers, data = payload2, files = files)
    payload3 = {
    'country_code': 'MX',
    'user_id': '4532',
    'session_id': '439-InjyJc39dwPumPisHS5xgw==',
    'solution_type': '3',
    'command': 'create',
    'name': 'Lorem ipsum dolor sit amet.',
    'affiliate_id': '4532',
    'from': '2020-07-09',
    'until': '2020-08-09',
    'refund_percentage': '10',
    'minimum_amount': '10'
    }
    response3 = requests.request("POST", url, headers=headers, data = payload3, files = files)
    print(response1.text.encode('utf8'))
    print(response2.text.encode('utf8'))
    print(response3.text.encode('utf8'))`
    },
    options: [
      {
        id: "python",
        type: "python",
        code: ` import requests
    url = "URL_BASE/ws/ws_soluciones.py/gestorsoluciones"
    payload1 = {
    'country_code': 'MX',
    'user_id': '4532',
    'session_id': '439-InjyJc39dwPumPisHS5xgw==',
    'solution_type': '1',
    'command': 'create',
    'name': 'Lorem ipsum dolor sit amet.',
    'from': '2020-07-09',
    'until': '2020-08-09',
    'point_value': '1'
    }
    files = []
    headers= {}
    response1 = requests.request("POST", url, headers=headers, data = payload1, files = files)
    payload2 = {
    'country_code': 'MX',
    'user_id': '4532',
    'session_id': '439-InjyJc39dwPumPisHS5xgw==',
    'solution_type': '2',
    'command': 'create',
    'name': 'Lorem ipsum dolor sit amet.',
    'from': '2020-07-09',
    'until': '2020-08-09',
    'condiciones_aceptacion': 'Lorem ipsum dolor sit amet.'
    }
    response2 = requests.request("POST", url, headers=headers, data = payload2, files = files)
    payload3 = {
    'country_code': 'MX',
    'user_id': '4532',
    'session_id': '439-InjyJc39dwPumPisHS5xgw==',
    'solution_type': '3',
    'command': 'create',
    'name': 'Lorem ipsum dolor sit amet.',
    'affiliate_id': '4532',
    'from': '2020-07-09',
    'until': '2020-08-09',
    'refund_percentage': '10',
    'minimum_amount': '10'
    }
    response3 = requests.request("POST", url, headers=headers, data = payload3, files = files)
    print(response1.text.encode('utf8'))
    print(response2.text.encode('utf8'))
    print(response3.text.encode('utf8'))`
      },
      {
        id: "nodejs",
        type: "javascript",
        code: ` var request = require('request');
  var formdata1 = {
  'country_code': 'MX',
  'user_id': '4532',
  'session_id': '439-InjyJc39dwPumPisHS5xgw==',
  'solution_type': '1',
  'command': 'create',
  'name': 'Lorem ipsum dolor sit amet.',
  'from': '2020-07-09',
  'until': '2020-08-09',
  'point_value': '1'
  };
  var formdata2 = {
  'country_code': 'MX',
  'user_id': '4532',
  'session_id': '439-InjyJc39dwPumPisHS5xgw==',
  'solution_type': '2',
  'command': 'create',
  'name': 'Lorem ipsum dolor sit amet.',
  'from': '2020-07-09',
  'until': '2020-08-09',
  'condiciones_aceptacion': 'Lorem ipsum dolor sit amet.'
  };
  var formdata3 = {
  'country_code': 'MX',
  'user_id': '4532',
  'session_id': '439-InjyJc39dwPumPisHS5xgw==',
  'solution_type': '3',
  'command': 'create',
  'name': 'Lorem ipsum dolor sit amet.',
  'affiliate_id': '4532',
  'from': '2020-07-09',
  'until': '2020-08-09',
  'refund_percentage': '10',
  'minimum_amount': '10'
  };
  var options = {
  'method': 'POST',
  'url': 'URL_BASE/ws/ws_soluciones.py/gestorsoluciones',
  'headers': {},
  formData: formdata1
  };
  request(options, function (error, response) { 
  if (error) throw new Error(error);
  console.log(response.body);
  });`
      },
      {
        id: "javascript",
        type: "javascript",
        code: ` var formdata1 = new FormData();
  formdata1.append("country_code", "MX");
  formdata1.append("user_id", "4532");
  formdata1.append("session_id", "439-InjyJc39dwPumPisHS5xgw==");
  formdata1.append("solution_type", "1");
  formdata1.append("command", "create");
  formdata1.append("name", "Lorem ipsum dolor sit amet.");
  formdata1.append("from", "2020-07-09");
  formdata1.append("until", "2020-08-09");
  formdata1.append("point_value", "1");
  var formdata2 = new FormData();
  formdata2.append("country_code", "MX");
  formdata2.append("user_id", "4532");
  formdata2.append("session_id", "439-InjyJc39dwPumPisHS5xgw==");
  formdata2.append("solution_type", "2");
  formdata2.append("command", "create");
  formdata2.append("name", "Lorem ipsum dolor sit amet.");
  formdata2.append("from", "2020-07-09");
  formdata2.append("until", "2020-08-09");
  formdata2.append("condiciones_aceptacion", "Lorem ipsum dolor sit amet.");
  var formdata3 = new FormData();
  formdata3.append("country_code", "MX");
  formdata3.append("user_id", "4532");
  formdata3.append("session_id", "439-InjyJc39dwPumPisHS5xgw==");
  formdata3.append("solution_type", "3");
  formdata3.append("command", "create");
  formdata3.append("name", "Lorem ipsum dolor sit amet.");
  formdata3.append("affiliate_id", "4532");
  formdata3.append("from", "2020-07-09");
  formdata3.append("until", "2020-08-09");
  formdata3.append("refund_percentage", "10");
  formdata3.append("minimum_amount", "10");
  var requestOptions = {
  method: 'POST',
  body: formdata1,
  redirect: 'follow'
  };
  fetch("URL_BASE/ws/ws_soluciones.py/gestorsoluciones", requestOptions)
  .then(response => response.text())
  .then(result => console.log(result))
  .catch(error => console.log('error', error));`
      },
      {
        id: "curl",
        type: "bash",
        code: ` curl --location --request POST 'URL_BASE/ws/ws_soluciones.py/gestorsoluciones'
  --form 'country_code=MX'
  --form 'user_id=4532'
  --form 'session_id=439-InjyJc39dwPumPisHS5xgw=='
  --form 'solution_type=2'
  --form 'command=create'
  --form 'name=Lorem ipsum dolor sit amet.'
  --form 'from=2020-07-09'
  --form 'until=2020-08-09'
  --form 'point_value=1'
  curl --location --request POST 'URL_BASE/ws/ws_soluciones.py/gestorsoluciones'
  --form 'country_code=MX'
  --form 'user_id=4532'
  --form 'session_id=439-InjyJc39dwPumPisHS5xgw=='
  --form 'solution_type=2'
  --form 'command=create'
  --form 'name=Lorem ipsum dolor sit amet.'
  --form 'from=2020-07-09'
  --form 'until=2020-08-09'
  --form 'condiciones_aceptacion=Lorem ipsum dolor sit amet.'
  curl --location --request POST 'URL_BASE/ws/ws_soluciones.py/gestorsoluciones'
  --form 'country_code=MX'
  --form 'user_id=4532'
  --form 'session_id=439-InjyJc39dwPumPisHS5xgw=='
  --form 'solution_type=3'
  --form 'command=create'
  --form 'name=Lorem ipsum dolor sit amet.'
  --form 'affiliate_id=4532'
  --form 'from=2020-07-09'
  --form 'until=2020-08-09'
  --form 'refund_percentage=10'
  --form 'minimum_amount=10'`
      }
    ]
  }

  return (
    <Fragment>
      <div className='container-fluid row'>
        <div className='col-md-7'>
          <h1 >Create a Solution</h1>
          <p>This service is used to create a solution in the system.</p>
          <p>
            <span className="label post">POST:</span>
            <span> </span>{' '}
            <code>URL_BASE + /ws/ws_soluciones.py/gestorsoluciones</code>
          </p>
          <h2 >Receives:</h2>
          <p>
            All the parameters that the service receives must be indicated in the body
            of the request.
          </p>
          <table>
            <thead>
              <tr>
                <th align="left">Parameter</th>
                <th align="center">Format</th>
                <th align="center">Obligatory</th>
                <th align="center">Description</th>
                <th align="center">Default value</th>
                <th align="center">Example</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td align="left">country_code</td>
                <td align="center">
                  <a href="https://www.iso.org/glossary-for-iso-3166.html">
                    ISO 3166 alpha-2
                  </a>
                </td>
                <td align="center">Yes</td>
                <td align="center">Country code in which the user resides</td>
                <td align="center">N/A</td>
                <td align="center">ES &#40;Spain&#41;</td>
              </tr>
              <tr>
                <td align="left">user_id</td>
                <td align="center">Integer</td>
                <td align="center">Yes</td>
                <td align="center">Identifier of the user making the request</td>
                <td align="center">N/A</td>
                <td align="center">4532</td>
              </tr>
              <tr>
                <td align="left">session_id</td>
                <td align="center">String</td>
                <td align="center">
                  Yes &#40;if you do not send signature to &#39;Access
                  Service&#39;&#41;
                </td>
                <td align="center">
                  Obtained by identifying the user with ID user_id on the platform
                </td>
                <td align="center">N/A</td>
                <td align="center">385-XadgYoWixbzN_wqWc3Yyog==</td>
              </tr>
              <tr>
                <td align="left">signature</td>
                <td align="center">String</td>
                <td align="center">
                  Yes &#40;if you do not send session_id to &#39;Access
                  Service&#39;&#41;
                </td>
                <td align="center">
                  Enables you to sign the request without having to log in
                </td>
                <td align="center">N/A</td>
                <td align="center">00d4c87a1dd9c87ccda8518bb007835a71233069</td>
              </tr>
              <tr>
                <td align="left">command</td>
                <td align="center">String</td>
                <td align="center">Yes</td>
                <td align="center">
                  It must contain the value <code>create</code>
                </td>
                <td align="center">N/A</td>
                <td align="center">create</td>
              </tr>
              <tr>
                <td align="left">solution_type</td>
                <td align="center">Integer</td>
                <td align="center">Yes</td>
                <td align="center">
                  It can containt the value 1 &#40;Points programme&#41;, 2
                  &#40;Charge order&#41;, 3 &#40;Refund promotion&#41;
                </td>
                <td align="center">N/A</td>
                <td align="center">1</td>
              </tr>
              <tr>
                <td align="left">name</td>
                <td align="center">String</td>
                <td align="center">Yes</td>
                <td align="center">Points program name</td>
                <td align="center">N/A</td>
                <td align="center"></td>
              </tr>
              <tr>
                <td align="left">from</td>
                <td align="center">String</td>
                <td align="center">Yes</td>
                <td align="center">Initial validity date of the points program</td>
                <td align="center">N/A</td>
                <td align="center">8-06-2020</td>
              </tr>
              <tr>
                <td align="left">until</td>
                <td align="center">String</td>
                <td align="center">Yes</td>
                <td align="center">Final validity date of the points program</td>
                <td align="center">N/A</td>
                <td align="center">28-06-2020</td>
              </tr>
            </tbody>
          </table>
          <p>Specific parameters of each type of solution:</p>
          <table>
            <thead>
              <tr>
                <th align="left">Parameter Type</th>
                <th align="center">Format</th>
                <th align="center">Obligatory</th>
                <th align="center">Description</th>
                <th align="center">Default value</th>
                <th align="center">Example</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td align="left">point_value</td>
                <td align="center">Integer</td>
                <td align="center">Yes</td>
                <td align="center">Value in pesos of 1 point</td>
                <td align="center">N/A</td>
                <td align="center">1</td>
              </tr>
              <tr>
                <td align="left">acception_conditions</td>
                <td align="center">String</td>
                <td align="center">Yes</td>
                <td align="center">
                  Text with the conditions that the user must accept.
                </td>
                <td align="center">N/A</td>
                <td align="center"></td>
              </tr>
              <tr>
                <td align="left">minimum_amount</td>
                <td align="center">Integer</td>
                <td align="center">Yes</td>
                <td align="center">
                  Amount in pesos from which the reimbursement occurs
                </td>
                <td align="center">N/A</td>
                <td align="center">50</td>
              </tr>
              <tr>
                <td align="left">refund_percentage</td>
                <td align="center">Integer</td>
                <td align="center">Yes</td>
                <td align="center">
                  Percentage to be returned to the user in transactions.
                </td>
                <td align="center">N/A</td>
                <td align="center">10</td>
              </tr>
              <tr>
                <td align="left">affiliate_id</td>
                <td align="center">Integer</td>
                <td align="center">Yes</td>
                <td align="center">
                  Identifier of the affiliate on which the refund is applied
                </td>
                <td align="center">N/A</td>
                <td align="center">4532</td>
              </tr>
            </tbody>
          </table>
          <h2 >Returns</h2>
          <p>
            Depending on the result of the operation, this service can return two
            different JSON:
          </p>
          <h3 >Answer JSON OK</h3>

          <div className='mb-3'>
            <DisplayCode1 codeToshow={codes.answe_ok1} />
          </div>
          <h2 >Where:</h2>
          <ul>
            <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
              <code>status:</code> Shows if the call has been successful
              &#40;true&#41; or not &#40;false&#41;.
            </li>
            <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
              <code>result:</code> Identifier of the solution of the selected type
              created.
            </li>
            <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
              <code>elapsed:</code> Operation execution time.
            </li>
            <li className="li-md" style={{fontSize:'1.2em', paddingLeft:'10px', marginLeft:'25px'}}>
              <code>codtran:</code> Transaction code that identifies the executed
              operation.
            </li>
          </ul>
          <h3 >Answer JSON KO:</h3>

          <div className='mb-3'>
            <DisplayCodeKo />
          </div>

          <h2 >Business Logic</h2>
          <p>
            This service generates a program of points controlled from the affiliate,
            and that is applied to the users that belong to the affiliate that has
            generated it.
          </p>

        </div>
        <div className='col-md-5'>
          <h2 >Example requests:</h2>
          <div className='effectStickySections'>

            <div className='mb-3'>
              <DisplayCode2 codeToshow={codesMutiple} />
            </div>

          </div>

        </div>

      </div>


    </Fragment>
  );
}
export default Crear_Solucion_EN;
